// hooks/useChangePassword.js
import { message } from 'antd';
import { useAxiosPrivate } from './useAxiosPrivate'; // Adjust the import path as needed
import OkModal from "../components/OkModal.js";
import { useAlert } from '../components/AlertContext.jsx';

const useChangePassword = () => {
    const axiosPrivate = useAxiosPrivate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const { triggerAlert } = useAlert(); // Add this if you want to use your alert system

    console.log("hook useChangePassword > START");

    const changePassword = async (username, values, user_id) => {

        console.log("username: ", username, " values:", values, " user_id: ", user_id);
        try {
            const response = await axiosPrivate.post(`${baseURL}/users-change-password`, {
                username: username,
                user_id: user_id,
                currentPassword: values.currentPassword,
                newPassword: values.newPassword,
            });


            // Always show the API message
            message[response.data.loginStatus ? 'success' : 'error'](response.data.message);
            return {
                success: response.data.loginStatus,
                message: response.data.message
            };

        } catch (error) {
            // Show detailed error message from API if available
            const errorMessage = error.response?.data?.message || 'Failed to change password';
            message.error(errorMessage);
            return {
                success: false,
                message: errorMessage
            };
        }
    };

    return { changePassword };
};

export default useChangePassword;
